import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-project-add-plantilla',
  templateUrl: './project-add-plantilla.component.html',
  styleUrls: ['./project-add-plantilla.component.scss']
})
export class ProjectAddPlantillaComponent implements OnInit {

  nombrePlantilla: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    public dialogRef: MatDialogRef<ProjectAddPlantillaComponent>,
    private projectsS: ProjectsService,
  ) { }

  ngOnInit(): void {
    
  }

  guardarPlantillaVobos(){

    if(this.nombrePlantilla.trim() == ''){
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Debe escribir un nombre para la plantilla'
      });
    }
    else{
      this.projectsS.setPlantillaVobos(this.data.phases, this.nombrePlantilla, this.data.id_proy).subscribe(
        (result:any) => {
          if(result.message == "Success"){
            Swal.fire({
              icon: 'success',
              title: 'Guardado',
              text: ''          
            }).then(() => {            
              this.dialogRef.close(result.id_res);
            });
          }
        },
        (err:any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar plantilla',
            text: 'Ocurrió un error al guardar plantilla'
          });
        }
      );
    }
    
  }

}
